import { DaysRange } from "../dayRange";

export default function takeRange(data: any[], range: DaysRange): any[] {
  if (range === 90) return data;

  return data.slice(range * -1);
}
